var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { CATALOG_TYPE_ACCOUNT_TYPE, CATALOG_TYPE_PAYMENT_MODE, PRODUCT_CATALOG_LIMIT, PRODUCT_CURRENCIES_ORDER_BY, PRODUCT_CURRENCIES_ORDER_DIR, PRODUCT_DEFAULT_PAGE, } from "../constants/productCreation.constants";
import { useRequestState } from "./useRequestState";
var SPONSORS_KEY = "getProductSponsors";
var INSURANCE_TYPES_KEY = "getProductInsuranceTypes";
var CURRENCIES_KEY = "getProductCurrencies";
var CATALOG_PAYMENT_MODES_KEY = "getProductCatalogPaymentModes";
var CATALOG_ACCOUNT_TYPES_KEY = "getProductCatalogAccountTypes";
var ALL_KEYS = [
    SPONSORS_KEY,
    INSURANCE_TYPES_KEY,
    CURRENCIES_KEY,
    CATALOG_PAYMENT_MODES_KEY,
    CATALOG_ACCOUNT_TYPES_KEY,
];
var toSelectList = function (items, label) {
    return (items !== null && items !== void 0 ? items : []).map(function (item) { return ({
        id: item.id,
        name: item[label],
        value: item.id,
    }); });
};
export var useProductCreationLookups = function (clientId) {
    var dispatch = useDispatch();
    var sponsors = useRequestState(SPONSORS_KEY);
    var insuranceTypes = useRequestState(INSURANCE_TYPES_KEY);
    var currencies = useRequestState(CURRENCIES_KEY);
    var paymentModes = useRequestState(CATALOG_PAYMENT_MODES_KEY);
    var accountTypes = useRequestState(CATALOG_ACCOUNT_TYPES_KEY);
    useEffect(function () {
        var base = {
            enable: true,
            page: PRODUCT_DEFAULT_PAGE,
            limit: PRODUCT_CATALOG_LIMIT,
        };
        dispatch(customRequestApis({
            requestKey: SPONSORS_KEY,
            method: "GET",
            path: "/asg/Api/V1/Sponsor",
            queryParams: __assign(__assign({}, base), { clientId: clientId }),
        }));
        dispatch(customRequestApis({
            requestKey: INSURANCE_TYPES_KEY,
            method: "GET",
            path: "/asg/Api/V1/ProjectType",
            queryParams: __assign(__assign({}, base), { clientId: clientId }),
        }));
        dispatch(customRequestApis({
            requestKey: CURRENCIES_KEY,
            method: "GET",
            path: "/asg/Api/V1/Currencies",
            queryParams: __assign(__assign({}, base), { orderBy: PRODUCT_CURRENCIES_ORDER_BY, orderDir: PRODUCT_CURRENCIES_ORDER_DIR }),
        }));
        dispatch(customRequestApis({
            requestKey: CATALOG_PAYMENT_MODES_KEY,
            method: "GET",
            path: "/asg/Api/V1/Catalog",
            queryParams: __assign(__assign({}, base), { type: CATALOG_TYPE_PAYMENT_MODE, clientId: clientId }),
        }));
        dispatch(customRequestApis({
            requestKey: CATALOG_ACCOUNT_TYPES_KEY,
            method: "GET",
            path: "/asg/Api/V1/Catalog",
            queryParams: __assign(__assign({}, base), { type: CATALOG_TYPE_ACCOUNT_TYPE, clientId: clientId }),
        }));
        return function () {
            ALL_KEYS.forEach(function (key) { return dispatch(clearCustomRequest(key)); });
        };
    }, []);
    var sponsorList = useMemo(function () { return toSelectList(sponsors.data, "name"); }, [sponsors.data]);
    var insuranceTypeList = useMemo(function () { return toSelectList(insuranceTypes.data, "description"); }, [insuranceTypes.data]);
    var currencyList = useMemo(function () { return toSelectList(currencies.data, "name"); }, [currencies.data]);
    var catalogPaymentModes = useMemo(function () { return toSelectList(paymentModes.data, "description"); }, [paymentModes.data]);
    var catalogAccountTypes = useMemo(function () { return toSelectList(accountTypes.data, "description"); }, [accountTypes.data]);
    return {
        insuranceTypeList: insuranceTypeList,
        sponsorList: sponsorList,
        currencyList: currencyList,
        catalogPaymentModes: catalogPaymentModes,
        catalogAccountTypes: catalogAccountTypes,
        loading: sponsors.loading || insuranceTypes.loading || currencies.loading,
        errors: {
            sponsors: sponsors.error,
            insuranceTypes: insuranceTypes.error,
            currencies: currencies.error,
            paymentModes: paymentModes.error,
            accountTypes: accountTypes.error,
        },
    };
};
